<template>
  <v-card max-height="90vh" min-height="90vh">
    <v-toolbar dense color="indigo">
      <v-toolbar-title class="white--text">
        Gestione Contenitori
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-data-table
        :expanded.sync="expanded_pedane"
        :headers="headers_pedane"
        item-key="id_lotto_pedana"
        :items="items_contenitori"
        class="elevation-0"
        height="73vh"
        show-expand
        :single-expand="true"
      >
        <!-- Colonna del numero righe -->
        <template v-slot:[`item.qta_righe`]="{ item }">
          {{ item.pedana_dettaglio ? item.pedana_dettaglio.length : 0 }}
        </template>

        <!-- Drill down degli articoli nella pedana -->
        <template v-slot:expanded-item="{ headers, item }">
          <td
            class="pa-0"
            style="background-color: white"
            :colspan="headers.length"
          >
            <v-data-table
              class="elevation-3"
              :headers="headers_articoli"
              hide-default-footer
              :items="item.pedana_dettaglio"
            >
              <template v-slot:top>
                <v-toolbar color="indigo" dense>
                  <v-toolbar-title class="white--text">
                    Articoli Inseriti
                  </v-toolbar-title>
                </v-toolbar>
              </template>
            </v-data-table>
          </td>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "GestionePedane",
  components: { SnackbarQV },
  props: {
    id_documento: {
      type: Number,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio

      // Modal

      // Array
      expanded_pedane: new Array(),
      headers_pedane: [
        {
          text: "N. Contenitore",
          value: "id_lotto_pedana",
          sortable: false,
        },
        {
          text: "N. Righe",
          value: "qta_righe",
          sortable: false,
        },
        {
          text: "Q.tà Totale",
          value: "qta_totale",
          sortable: false,
        },
      ],
      headers_articoli: [
        {
          text: "Num. Riga Ordine",
          value: "num_riga",
          sortable: false,
        },
        {
          text: "Cod. Articolo",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Des. Articolo",
          value: "descrizione",
          sortable: false,
        },
        {
          text: "Q.tà Ordine",
          value: "quantita",
          sortable: false,
        },
        {
          text: "Q.tà Prelevata",
          value: "quantita1",
          sortable: false,
        },
        {
          text: "Num. Colli",
          value: "num_colli",
          sortable: false,
        },
      ],
      items_contenitori: [],
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          // Ricarico le pedane
          this.getPedane();

          // Chiudo tutti i drill down
          this.expanded_pedane = new Array();
        }
      },
    },
  },
  methods: {
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    getPedane() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpedane",
          token: localStorage.getItem("user_token"),
          id_documento: this.id_documento,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_contenitori = Array.from(res.data.result.pedane);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          if (err) {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>